import { Is_Student_Available_OPTIONS, IS_EXTERNAL_COMPANY, YES_OR_NO_INTERNSHIP_JOINED, YES_OR_NO_INTERNSHIP_COMPLETED } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaSelectModel, SmDatepickerModel, SmMetaInputModel, SmBtnMetaModel, SmMetaMultipleChoiceModel } from "common/models/utility-models/meta-model";

export class InternshipDetailsMetaModel extends FormMetaModel {
    constructor() {
        super(` Student Internship Details`, '', '', 3);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const isStudentAvailable = new SmMetaSelectModel(
            'isStudentAvailable',
            'isStudentAvailable',
            'select',
            true,
            'col-12 ',
            1,
            1,
            'Is Student Available ?',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            Is_Student_Available_OPTIONS,
            'name',
            'id',
            false,
            false,
            false,
            false,
            false,
            false
          );
        const semesterExamStart = new SmDatepickerModel(
            'semesterExamStart',
            'semesterExamStart',
            'datepicker',
            true,
            'col-12 col-md-6',
            1,
            1,
            '4th/6th Semester Exam Start',
            'text',
            '',
            false,
            true,
            true,
            false,
            false,
            'DD/MM/YYYY',
            new Date('1970-10-19'),
            new Date('2040-01-01'),
            false
        );

       
        const semesterExamEnds = new SmDatepickerModel(
            'semesterExamEnds',
            'semesterExamEnds',
            'datepicker',
            true,
            'col-12 col-md-6',
            1,
            1,
            '4th/6th Semester Exam Ends',
            'text',
            '',
            false,
            true,
            true,
            false,
            false,
            'DD/MM/YYYY',
            new Date('1970-10-19'),
            new Date('2040-01-01'),
            false
        );

        const summerVacationStarts = new SmDatepickerModel(
            'summerVacationStarts',
            'summerVacationStarts',
            'datepicker',
            true,
            'col-12 col-md-6',
            1,
            1,
            'Summer Vacation Starts',
            'text',
            '',
            false,
            true,
            true,
            false,
            false,
            'DD/MM/YYYY',
            new Date('1970-10-19'),
      new Date('2040-01-01'),
            false
        );

        const summerVacationEnds = new SmDatepickerModel(
            'summerVacationEnds',
            'summerVacationEnds',
            'datepicker',
            true,
            'col-12 col-md-6',
            1,
            1,
            'Summer Vacation Ends',
            'text',
            '',
            false,
            true,
            true,
            false,
            false,
            'DD/MM/YYYY',
            new Date('1970-10-19'),
            new Date('2040-01-01'),
            false
        );

        const isExternalCompanyForInternship = new SmMetaSelectModel(
            'isExternalCompanyForInternship',
            'isExternalCompanyForInternship',
            'select',
            false,
            'col-12 ',
            1,
            1,
            'Do you have any other internship ?',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            IS_EXTERNAL_COMPANY,
            'name',
            'id',
            false,
            false,
            false,
            false,
            false,
            false
          );

        const internshipStartDate = new SmDatepickerModel(
            'internshipStartDate',
            'internshipStartDate',
            'datepicker',
            true,
            'col-12 col-md-6',
            1,
            1,
            'Internship Start Date',
            'text',
            '',
            false,
            true,
            true,
            false,
            false,
            'DD/MM/YYYY',
            new Date('1970-10-19'),
            new Date('2040-01-01'),
            false
        );

        const internshipEndDate = new SmDatepickerModel(
            'internshipEndDate',
            'internshipEndDate',
            'datepicker',
            true,
            'col-12 col-md-6',
            1,
            1,
            'Internship End Date',
            'text',
            '',
            false,
            true,
            true,
            false,
            false,
            'DD/MM/YYYY',
            new Date('1970-10-19'),
            new Date('2040-01-01'),
            false
        );

        const studentAvailabilityRemark = new SmMetaInputModel(
            'studentAvailabilityRemark',
            'studentAvailabilityRemark',
            'input',
            false,
            'col-12 col-md-6',
            1,
            1,
            'Remarks (if any)',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1
        );

        const externalCompanyName = new SmMetaInputModel(
            'externalCompanyName',
            'externalCompanyName',
            'input',
            false,
            'col-12 col-md-6',
            1,
            1,
            'Company Name',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1
        );

        const externalCompanyLocation = new SmMetaInputModel(
            'externalCompanyLocation',
            'externalCompanyLocation',
            'input',
            false,
            'col-12 col-md-6',
            1,
            1,
            'Company Location',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1
        );

        const isStudentJoined = new SmMetaMultipleChoiceModel(
            'isStudentJoined',
            'isStudentJoined', 
            "singleChoice",
            false,
            "col-12 col-md-6",
            1,
            2,
            'Have you joined your Internship ?',
            "number",
            "",
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            YES_OR_NO_INTERNSHIP_JOINED,
            "",
            "id",
            false,
            false,
            false,
            false,
            false,
            false
          );

          const reasonForNotJoined = new SmMetaInputModel(
            'reasonForNotJoined',
            'reasonForNotJoined',
            'input',
            false,
            'col-12 col-md-6',
            1,
            1,
            'Reason',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1
        );

        const isStudentContinued = new SmMetaMultipleChoiceModel(
            'isStudentContinued',
            'isStudentContinued', 
            "singleChoice",
            false,
            "col-12 col-md-6",
            1,
            2,
            'Have you completed your Internship ?',
            "number",
            "",
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            YES_OR_NO_INTERNSHIP_COMPLETED,
            "",
            "id",
            false,
            false,
            false,
            false,
            false,
            false
          );

          const reasonForNotContinued = new SmMetaInputModel(
            'reasonForNotContinued',
            'reasonForNotContinued',
            'input',
            false,
            'col-12 col-md-6',
            1,
            1,
            'Reason',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1
        );

        const buttons = {
            submit: new SmBtnMetaModel('Add', '', true, false, true, true),
            // isFormControl: false
        };


        return {
            formInfo,
            buttons,
            isStudentAvailable,
            semesterExamStart,
            semesterExamEnds,
            summerVacationStarts,
            summerVacationEnds,
            isExternalCompanyForInternship,
            internshipStartDate,
            internshipEndDate,
            studentAvailabilityRemark,
            externalCompanyName,    
            externalCompanyLocation,
            isStudentJoined,
            reasonForNotJoined,
            isStudentContinued,
            reasonForNotContinued
        }
    }
}